<template>
  <div class="flex items-center rounded">
    <UiFlag :country="info.country" />&nbsp;
    <span class="flex-1 mr-2 font-bold">{{ info.nick }}</span>
    <UiIconStack class="icon" :icon2="`text-gray-400 fa fa-${info.staff}`" v-if="info.staff" />
    <UiIconStack class="icon" icon2="fa fa-eye text-gray-400" :title="t('spectator')" v-if="info.spectator" />
    <UiIconStack class="icon" icon2="fa fa-user text-yellow-300" :title="t('duelPlayer')" v-if="info.day1" />
    <UiIconStack class="icon" icon2="fa fa-users text-red-300" :title="t('draftPlayer')" v-if="info.day2" />
    <UiIconStack class="icon" icon2="fab fa-twitch text-purple-300" :href="`https://twitch.tv/${info.twitch}`" :title="t('twitch')" v-if="info.twitch" />
  </div>
</template>

<script>
  import { useI18n } from 'vue-i18n'
  export default {
    name: 'UiParticipant',
    props: {
      info: {
        type: Object,
      },
    },
    setup() {
      const { t } = useI18n({
        messages: {
          en: {
            spectator: 'VIP spectator',
            duelPlayer: 'Duel participant',
            draftPlayer: 'Draft participant',
            twitch: 'Stream',
          },
          ru: {
            spectator: 'VIP зритель',
            duelPlayer: 'Участник дуэлей',
            draftPlayer: 'Участник драфта',
            twitch: 'Стрим',
          },
        },
      })
      return { t }
    },
  }
</script>

<style lang="postcss" scoped>
  .icon {
    @apply -mx-1 cursor-pointer opacity-50;
  }
  .icon:hover {
    @apply opacity-75;
  }
</style>
